import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  ApiVisa,
  BaseApiTemplateService,
  PagingResponseModel
} from '../../shared';
import {Core2Config} from '../../shared';
import {
  EntitlementAutoTopUpRunTxnLineContainerModel
} from '../../../../../../models';
import {Observable} from 'rxjs';

export class GenerateLinesBodyRequest {
  auto_top_up_run_txn_line_guids: string[];

}

@Injectable({
  providedIn: 'root'
})
export class EntitlementAutoTopUpRunTxnLineService extends BaseApiTemplateService<EntitlementAutoTopUpRunTxnLineContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/txn-lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/txn-lines/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/txn-lines/backoffice-ep';
    this.httpClient = http;
  }

  generateTxnLines(body: GenerateLinesBodyRequest, apiVisa: ApiVisa): Observable<PagingResponseModel<EntitlementAutoTopUpRunTxnLineContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/txn-lines/processors/generate-claim-account-txn-lines/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/txn-lines/processors/generate-claim-account-txn-lines/backoffice-ep';
    }
    return this.httpClient.post<PagingResponseModel<EntitlementAutoTopUpRunTxnLineContainerModel>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

}


